/**
 * Fallback shown while a lazily-loaded route chunk downloads.
 *
 * Routes are code-split (see controller/Routes.jsx), so this sits inside the
 * layout's Suspense boundary — the header and footer stay put and only the
 * page body swaps out. min-height roughly matches a hero so navigation does
 * not collapse the page and bounce the footer up.
 */
const PageLoader = () => (
  <div className="page-loader" role="status" aria-live="polite">
    <span className="page-loader__spinner" aria-hidden="true" />
    <span className="sr-only">Loading…</span>
  </div>
);

export default PageLoader;
